{
  "accepted": "Accepted",
  "acceptTerms": "Accept terms and conditions",
  "accountSettings": "Account settings",
  "active": "Active",
  "active_plural": "Active",
  "activity": "Activity",
  "actorsForProgram": "Actors in the {{programName}}-program",
  "actorsForProgramDescription": "List of actors in the {{programName}}-program. As administrator you have read access to all content.",
  "add": "Add",
  "addComment": "Add comment",
  "addCost": "Add cost",
  "addNewRow": "Add new row",
  "addNote": "Add note",
  "address": "Address",
  "advisor": "Advisor",
  "all": "All",
  "alerts": "Notifications",
  "alreadyExists": "Already exists",
  "amount": "Amount",
  "applicantCompany": "Applicant company",
  "approve": "Approve",
  "approved": "Approved",
  "archive": "Archive",
  "ariaLabelReportSaveStatusSection": "Last saved status",
  "ariaLabelTopMenuSection": "Top menu",
  "at": "At",
  "attachment": "Attachment",
  "attachments": "Attachments",
  "back": "Back",
  "background": "Background",
  "baseInfo": "Basic information",
  "baseReport": "Base report",
  "billingAddress": "Billing address",
  "budget": "Budget",
  "businessGarden": "Business garden",
  "cancel": "Cancel",
  "cannotBeUndone": "This action cannot be undone.",
  "cannotRead": "You do not have read access for this.",
  "cannotWrite": "You do not have write access for this.",
  "caseNumber": "Case number",
  "category": "Category",
  "choose": "Choose",
  "chooseActor": "Choose actor",
  "chooseCluster": "Choose cluster",
  "chooseClusterChosen": "Chosen network",
  "chooseClusterTitle": "Choose cluster - Multicompanyportal",
  "chooseCounty": "Choose county",
  "chooseFiles": "Select files",
  "chooseReport": "Choose report",
  "chooseMunicipality": "Choose municipality",
  "chooseStatus": "Choose Status",
  "chosenActor": "Chosen actor",
  "close": "Close",
  "closeDialog": "Close dialog",
  "textArea.charactersLeft": "%d characters left",
  "textArea.charactersOver": "%d characters too many",
  "jobTitle": "Job Title",
  "cluster": "Cluster",
  "clusterLeader": "Network leader",
  "clusterManager": "Cluster manager",
  "boardChairman": "Board chairman",
  "boardMember": "Board member",
  "boardVaraMember": "Deputy board member",
  "projectManager": "Project manager",
  "clusterName": "Network name",
  "clusterOperation": "Cluster operation",
  "column": "Column",
  "comment": "Comment",
  "commenting": "Comment",
  "companies": "Companies",
  "company": "Company",
  "completed": "Completed",
  "notCompleted": "Not completed",
  "contact": "Contact",
  "contactInformation": "Contact information",
  "contactPerson": "Contact person",
  "contactStatus": "Contact status",
  "contactUsForSolution": "Please contact us to find another solution.",
  "continue": "Continue",
  "cooperation": "Cooperation",
  "copyLink": "Copy link",
  "cost": "Cost",
  "costs": "Costs",
  "costType": "Cost type",
  "costTypes": "Cost types",
  "costTypeTitle": "Title of cost type",
  "count": "Count",
  "county": "County",
  "course": "Course",
  "create": "Create",
  "createAttachment": "Create attachment",
  "created": "Created",
  "createReport": "Create report",
  "customer": "Customer",
  "customerInfo": "Customer Info",
  "customerInformation": "Customer information",
  "date": "Date",
  "dateNotSet": "Date not set",
  "default": "Default",
  "delete": "Delete",
  "deleteSelected": "Delete selected",
  "deleted": "Deleted",
  "deleting": "Deleting",
  "delivered": "Delivered",
  "selfDeclarationStatusDeliveredOnDate": "Valid to {{date}}",
  "expiresSoon": "Expires soon",
  "selfDeclarationExpired": "Expired",
  "selfDeclarationStatusExpiresOnDate": "Expires on {{date}}",
  "missing": "Missing",
  "notDelivered": "Not delivered",
  "description": "Description",
  "developmentReport": "Development report",
  "done": "Done.",
  "doNotSendEmail": "Do not send email",
  "download": "Download",
  "downloading": "Downloading",
  "downloadAttachment": "Download Attachment",
  "downloadTemplate": "Download template",
  "dragFiles": "or drag them here.",
  "economy": "Economy",
  "edit": "Edit",
  "editTabelView": "Edit table view",
  "email": "Email",
  "employee": "Employee",
  "emptyList": "Empty list",
  "end": "End",
  "endDate": "End date",
  "errorAcceptConsent": "Our apologies! An error has occured in our internal systems. Please try again as it may have been a temporary error. If the problem persists please try again later.",
  "establishmentDate": "Establishment date",
  "event": "Event",
  "eventRegistration.completionGratitude": "Thank you for registrating your participation!",
  "eventRegistration.errorRepeat": "Could not send the registration. Could you please try again?",
  "eventRegistration.errorUnavailable": "Chosen event is unavailable for registration.",
  "eventRegistration.formAddCompanyNameOrNumber": "Write either the company name or number. If you do not find it in the dropdown list, just leave the name in.",
  "eventRegistration.formAddContactInfo": "Add contact information",
  "eventRegistration.formAdjustHours": "Adjust hours",
  "eventRegistration.formAdjustHoursDescription": "Here you can add hours for travel og preparation in addition to the event. Hours spent on the event is already set.",
  "eventRegistration.formDescriptionText": "You may add a description if you change time spent on the event. This may be due to travel, preparations or something else.",
  "eventRegistration.formMyEmail": "My email",
  "eventRegistration.formRegisterHours": "Register hours",
  "eventRegistration.formSendRegistration": "Send in registration",
  "eventRegistration.formTitle": "Register your participation",
  "eventRegistration.title": "Event registration",
  "export": "Export",
  "exportToExcel": "Export to Excel",
  "female": "Female",
  "fetching": "Loading...",
  "fetchingEvents": "Fetching events...",
  "fetchingHourRate": "Fetching hour rate...",
  "fetchingProjects": "Fetching projects...",
  "fieldIsRequired": "This field is required.",
  "required": "Required",
  "fieldsOfInterest": "Fields of interest",
  "filter": "Filter",
  "filterBy": "Filter by",
  "filterLeads": "Filter leads",
  "filterMembers": "Filter members",
  "filters": "Filters",
  "financing": "Financing",
  "financingSource": "Financing source",
  "financingTitleLable": "Title of financing",
  "firstName": "First name",
  "lastName": "Last name",
  "footer.contact": "Contact us.",
  "footer.copyright": "Copyright © {{ date }}. All rights reserved",
  "footer.questionsAboutPortal": "Questions about the multi-company portal?",
  "from": "From",
  "frontpage.alerts.none": "There are no new alerts.",
  "gender": "Gender",
  "goalAchievement": "Goal achievement",
  "goBack": "Go back",
  "gotoAdminStatistics": "Go to admin statistics",
  "goToCourse": "Go to course",
  "goToMainPage": "Go to main page",
  "halfYearReports": "Half year reports",
  "here": "here",
  "hide": "Hide",
  "historic": "Historic",
  "history": "History",
  "hits": "hits",
  "homeError4XX": "Something failed in the communication between our services. We could not log you in.",
  "homeError5XX": "Something failed internally in our services. We could not log you in.",
  "homeErrorContactLinkPart1": "If you are unable to log into the portal you can reach oss",
  "homeErrorContactLinkPart2": "or send a mail to flerbedriftsportal@innovasjonnorge.no.",
  "homeErrorNoActors": "It looks like you are not connected to any actors. To use the portal you must be invited by a person in an actor with access.",
  "homeErrorNotRegistered": "It looks like your user is not registered. Contact an actor to get an activation link.",
  "hours": "Hours",
  "ideas": "Ideas",
  "imported": "Imported",
  "inactive": "Inactive",
  "inactive_plural": "Inactive",
  "incubator": "Incubator",
  "info": "Info",
  "inCollaboration": "In collaboration",
  "inCollaborationWith": "In collaboration with",
  "industry": "Industry",
  "inkind": "In kind",
  "innovationNorway": "Innovation Norway",
  "inProgress": "In progress",
  "international": "International",
  "invalid": "Invalid",
  "invitationStatus": "Invitation status",
  "keep": "Keep",
  "language": "Language",
  "lastChanged": "Last changed",
  "link": "Link",
  "linkCopied": "Link copied!",
  "invalidValue": "Invalid value",
  "loading": "Loading",
  "loadingData": "Loading data",
  "loadingAttachments": "Loading attachments...",
  "tryAgain": "Try again",
  "MulticompanyPortal": "MulticompanyPortal",
  "loadingMulticompanyPortal": "Loading multicompanyportal...",
  "loadingMulticompanyPortalClusters": "Retrieving clusters...",
  "loadingMulticompanyPortalPermissions": "Retrieving permissions...",
  "loadingMulticompanyPortalRetrievingUser": "Retrieving user...",
  "loadingMulticompanyPortalTitle": "Loading multicompanyportal",
  "location": "Location",
  "logIn": "Log in",
  "logInEmployee": "Employee in Innovation Norway? Click here.",
  "logOut": "Log out",
  "mailingAddress": "Mailing address",
  "mainGoal": "Main goal",
  "mainMenu": "Main menu",
  "header.contact": "How can we help you?",
  "maintenanceHeader": "The Multicompanyportal is down for maintenance",
  "maintenanceText": "Thank you for your patience. You can reach us through:",
  "male": "Male",
  "manually": "Manually",
  "memberCategories": "Member categories",
  "memberSince": "Member since",
  "membersPerCounty": "Members per county",
  "memberTypes": "Member types",
  "min": "min",
  "missing": "Missing",
  "mobile": "Mobile",
  "mobilePhone": "Mobile phone",
  "move": "Move",
  "moveDown": "Move down",
  "moveUp": "Move up",
  "multicompanyPortalWelcome": "Welcome to the Multicompanyportal!",
  "municipality": "Municipality",
  "municipalityNumber": "Municipality number",
  "name": "Name",
  "navbar.skipToContent": "Skip to Content",
  "new": "New",
  "newAttachment": "New attachment",
  "next": "Next",
  "nextPage": "Next page",
  "nextYear": "Next year",
  "no": "No",
  "noAccess": "No access",
  "noAccessExplanation": "You do not have access to this page. Please either go back to the main page or choose something else in the menu.",
  "noAttachments": "No attachments",
  "noChangePermissions": "You do not have permission to do changes.",
  "noHits": "No results",
  "nonCounting": "Non counting",
  "none": "None",
  "note": "Note",
  "opensInNewTab": "Opens in a new tab",
  "notVisible_plural": "Not visible",
  "numberOfEmployees": "Number of employees",
  "numberOfHours": "Number of hours",
  "numberOfMinutes": "Number of minutes",
  "numberOfParticipants": "Number of participants",
  "of": "of",
  "ofTotal": "of a total of",
  "OK": "OK",
  "old": "Old",
  "oldestToNewest": "Oldest to newest",
  "ongoing": "Ongoing",
  "operationResultListDescription": "{{ success }} was successfult, and {{ errors }} failed. Do you want to se details?",
  "optional": "optional",
  "optionalCapitalized": "Optional",
  "organizationNumber": "Organization number",
  "orgNr": "Org nr.",
  "other": "Other",
  "overview": "Overview",
  "participants": "Participants",
  "participatingCompany": "Participating company",
  "pendingApproval": "Pending approval",
  "phase": "Phase",
  "piece": "piece",
  "piece_plural": "pieces",
  "postalCity": "City",
  "previous": "Previous",
  "previousPage": "Previous page",
  "previousYear": "Previous year",
  "project": "Project",
  "project_one": "Project",
  "project_other": "Projects",
  "projectTypes": "Project types",
  "readTerms": "I have read the terms of use.",
  "reason": "Reason",
  "recommend": "Recommend",
  "recommendedCourses": "Recommended courses for members",
  "register": "Register",
  "registration": "Registration",
  "registrationLink": "Registration link",
  "remove": "Remove",
  "removeRow": "Remove row",
  "removeSelected": "Remove selected",
  "reopen": "Resume",
  "reports": "Reports",
  "reply": "Reply",
  "reset": "Reset",
  "responsibility": "Responsibility",
  "responsible": "Responsible",
  "result": "Result",
  "retiermentDate": "Retirement date",
  "role": "Role",
  "roles": "Roles",
  "row": "Row",
  "rowSelected": "Row selected",
  "row_plural": "Rows",
  "rowsPerPage": "Rows per page",
  "rowsSelected": "Rows selected",
  "save": "Save",
  "saveAsPdf": "Save as PDF",
  "saving": "Saving...",
  "search": "Search",
  "searchEmail": "Search email",
  "searchForActor": "Search for actor",
  "searchMobile": "Search mobile",
  "searchName": "Search name",
  "searchNumberOfParticipants": "Search number of participants",
  "searchTelephone": "Search telephone",
  "seeAll": "See all",
  "seeAllCompCenter": "See all in the Competence center",
  "seeMoreStats": "See more statistics",
  "select": "Select",
  "selectColumns": "Select columns",
  "selectLanguage": "Select language",
  "selectYear": "Select year",
  "send": "Send",
  "sendEmail": "Send email",
  "sent": "Sent",
  "sentBack": "Sent back",
  "sessionExipredDescription": "Your session has exipred, sign in again to access the portal.",
  "sessionExipredTitle": "Your session has exipred!",
  "shortCuts": "Shortcuts",
  "shortcuts": "Shortcuts",
  "show": "Show",
  "showAll": "Show all",
  "showAllColumns": "Show all columns",
  "showDetails.hide": "Skjul detaljer",
  "showDetails.show": "Vis detaljer",
  "showEmailToggle.hide": "Hide email",
  "showEmailToggle.show": "Show email",
  "showFailed": "Show failed",
  "showMore": "Show more",
  "showOnlySelected": "Show only selected",
  "showSucceeded": "Show succeeded",
  "startCourse": "Start course",
  "startDate": "Start date",
  "startup": "Startup",
  "statistics": "Statistics",
  "statistics.noData": "No data",
  "status": "Status",
  "submit": "Submit",
  "sum": "Sum",
  "summary": "Summary",
  "surname": "Surname",
  "tasks": "Tasks",
  "telephone": "Telephone",
  "termsMustBeAccepted": "Sorry, you must accept the terms of use to log in to the multi-company portal.",
  "termsOfUse": "User agreement for Flerbedriftsportalen",
  "timeRate": "Time rate",
  "to": "To",
  "toEnterYouMustApprove": "To enter the multi-company portal you have to accept",
  "toFrontpage": "To frontpage",
  "releaseNotes": "What's new in Flerbedriftsportalen",
  "releaseNotes.useful": "Useful",
  "releaseNotes.voted": "voted useful",
  "releaseNotes.seeAll": "See all news",
  "total": "Total",
  "type": "Type",
  "unspecified": "Unspecified",
  "unsubscribe": "Unsubscribe",
  "unsubscribed": "Unsubscribed",
  "uploadFile": "Upload file",
  "userActivation.activationHeader": "Welcome!",
  "userActivation.activationLoader": "Activating portal invitation. Please wait...",
  "userActivation.activationLoginRequest": "To accept the invitation please log in through id-porten.",
  "userActivation.activationTextDescription": "The Multi Company Portal is a platform that is offered to clusters and networks. ",
  "userActivation.activationTextInvitation": "You have been invited to Innovation Norway's Multi Company Portal",
  "userActivation.errorHeader": "Activation failed.",
  "userActivation.errorText": "This may have been due to an invalid activation code or you are already registered.",
  "userActivation.title": "User activation",
  "visible": "Visible",
  "visible_plural": "Visible",
  "website": "Website",
  "withoutName": "Unnamed",
  "writeComplementary": "Write complementary",
  "writeHere": "Write here",
  "writeInDetail": "Write in detail",
  "writeInDetailMandatory": "Write in detail (mandatory)",
  "year": "Year",
  "yes": "Yes",
  "zipCode": "Zip code",
  "footer.innovasjonNorge.logo.altText": "Innovation Norway",
  "footer.declarityOfAvailability": "Declaration of availability",
  "courses.recommendationSent": "Recommendation sent!",
  "sending": "Sending...",
  "courses.sendRecommendation": "Send recommendation",
  "courses.recommendCourse": "Recommend course",
  "oneWayIn": "One way in",
  "sivaReporting": "SIVA Reporting",
  "contactSupport": "Contact user support",
  "contactUsByEmail": "Contact us by e-mail",
  "howCanWeHelp": "You can reach us through the following e-mail:",
  "showLess": "Show less",
  "organization": "Organization",
  "confirmation": "Confirmation",
  "and": "and",
  "fromDate": "From",
  "toDate": "To",
  "december": "December",
  "numberOfResults": "{{ resultsCount }} results found",
  "oneResult": "One result found",
  "noResults": "The search found no results. Please try adjusting the filters or using a different query.",
  "actorTypes.cluster": "Clusters",
  "actorTypes.oneWayIn": "One way in",
  "actorTypes.sivaAdmin": "Siva admin",
  "step": "Step",
  "ceo": "CEO",
  "monthly": "Monthly",
  "weekly": "Weekly",
  "never": "Never",
  "updateFailed": "Something failed",
  "notSet": "Not set",
  "accessControl": "Access control",
  "addNew": "Add new",
  "registered": "Registered",
  "notRegistered": "Not registered",
  "notApplicable": "Not applicable",
  "readMore": "Read more",
  "readLess": "Read less",
  "copied": "Copied!",
  "copy": "Copy",
  "actors": "Actors",
  "sendResponse": "Send response",
  "sendResponseAndRefer": "Send response and go to referral",
  "clusterStatus.OWI_ACTOR": "One Way In",
  "clusterStatus.INCUBATOR": "Incubator",
  "clusterStatus.BUSINESS_GARDEN": "Business Garden",
  "clusterStatus.NIC_KLYNGE_2025": "Norwegian Innovation Cluster",
  "editTableView.tooltip": "Choose which columns to display \nin the table, and order them.",
  "draft": "Draft",
  "emailSent": "Email sent",
  "emailSentDetails": "Email was sent to {{ email }}",
  "emailNotSent": "Email not sent",
  "by": "By",
  "seeMore": "See more",
  "seeLess": "See less",
  "bold": "Bold",
  "italic": "Italic",
  "underline": "Underline",
  "unorderedList": "Unordered list",
  "orderedList": "Ordered list",
  "getInContact": "Get in contact",
  "toTheTop": "To the top",
  "needHelp": "Need help?",
  "subject": "Subject",
  "allInvoices": "All invoices",
  "byCompany": "By company",
  "invoiceAreReadyForImport": "Invoices are ready for import. Complete the import with the button below.",
  "invoicesImportedSuccessfully": "Invoices imported successfully.",
  "allYears": "All years",
  "unknown": "Unknown"
}
